import * as Yup from 'yup'

const fastSellProductEntrupyFormSchema = () => (
  Yup.object().shape({
    entrupy_image: Yup.array()
      .min(1, 'Required')
  })
)

export default fastSellProductEntrupyFormSchema
